export const paginasDeslogadasProps = {
  basename: "/laboratorio",
};
